module.exports = __webpack_public_path__ + "static/media/cardiogram.dc686425.png";